<div class="page-content-wrapper block--wrap block">
    <ng-content></ng-content>
</div>
